import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Full-screen banner that appears when a new era is unlocked. Handles its own
// animation and calls onDismiss when done.
export const EraBanner = ({ upgrade }) => {
  return (
    <AnimatePresence>
      {upgrade && (
        <motion.div
          initial={{ opacity: 0, y: -80, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -80, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 220, damping: 22 }}
          className="fixed inset-x-0 top-1/4 z-40 pointer-events-none flex justify-center px-4"
          data-testid="era-banner"
        >
          <div
            className="max-w-xl w-full text-center p-6 sm:p-8 border-2"
            style={{
              backgroundColor: "#111",
              borderColor: "#FFD400",
              borderRadius: 2,
              boxShadow: "0 0 60px rgba(255,212,0,0.35)",
            }}
          >
            <div
              className="text-[10px] sm:text-xs uppercase tracking-[0.5em] mb-3"
              style={{ color: "#FFD400", fontFamily: "Orbitron, sans-serif" }}
            >
              New Era Unlocked
            </div>
            <div
              className="text-2xl sm:text-4xl font-black uppercase tracking-wider"
              style={{
                color: "#FFFFFF",
                fontFamily: "Orbitron, sans-serif",
                textShadow: "0 0 20px rgba(255,212,0,0.6)",
              }}
              data-testid="era-banner-title"
            >
              {upgrade.name}
            </div>
            <div className="mt-3 text-xs sm:text-sm text-white/70 max-w-md mx-auto">
              {upgrade.description}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EraBanner;
